export class UserPreferenceModel {
  djjUserAcId: number;
  contentPosition = 1;
  bannerPosition = 1;
  bannerFullScreen = false;
  background = 'logo';
}
